import { render, staticRenderFns } from "./petroleumIndustrial.vue?vue&type=template&id=11e60919&scoped=true&"
import script from "./petroleumIndustrial.vue?vue&type=script&lang=js&"
export * from "./petroleumIndustrial.vue?vue&type=script&lang=js&"
import style0 from "./petroleumIndustrial.vue?vue&type=style&index=0&id=11e60919&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e60919",
  null
  
)

export default component.exports